import { render, staticRenderFns } from "./ConnectionCustomer.vue?vue&type=template&id=9f07d2bc&scoped=true"
import script from "./ConnectionCustomer.vue?vue&type=script&lang=ts"
export * from "./ConnectionCustomer.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionCustomer.vue?vue&type=style&index=0&id=9f07d2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f07d2bc",
  null
  
)

export default component.exports